import React from 'react';
import { Helmet } from 'react-helmet';

export const SchemaOrg: React.FC = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": "Theo Goodman",
    "givenName": "Theo",
    "familyName": "Goodman",
    "url": "https://www.hellogoodman.com",
    "image": "https://www.hellogoodman.com/images/theo-open-graph.jpg",
    "sameAs": [
      "https://twitter.com/theojeffgood",
      "https://github.com/theojeffgood",
      "https://www.linkedin.com/in/theojeffgood"
    ],
    "jobTitle": "Software Engineer & Product Manager",
    "worksFor": {
      "@type": "Organization",
      "name": "Half Lemons"
    },
    "knowsAbout": [
      "Software Development",
      "Product Management",
      "iOS Development",
      "User Experience Design"
    ],
    "makesOffer": [
      {
        "@type": "SoftwareApplication",
        "applicationCategory": "FoodService",
        "applicationSubCategory": "Recipe",
        "operatingSystem": "iOS",
        "name": "Half Lemons",
        "description": "Recipe finder using ingredients you have",
        "url": "https://www.halflemons.com",
        "offers": {
          "@type": "Offer",
          "price": "0",
          "priceCurrency": "USD"
        }
      },
      {
        "@type": "WebApplication",
        "applicationCategory": "Shopping",
        "name": "Gains",
        "description": "Fitness lifestyle brand",
        "url": "https://gainsapparel.netlify.app"
      },
      {
        "@type": "SoftwareApplication",
        "applicationCategory": "FoodService",
        "applicationSubCategory": "Recipe",
        "operatingSystem": "iOS",
        "name": "Dinners App",
        "description": "Tinder-style recipe matching app for families",
        "url": "https://www.dinnersapp.com",
        "offers": {
          "@type": "Offer",
          "price": "0",
          "priceCurrency": "USD"
        }
      },
      {
        "@type": "SoftwareApplication",
        "applicationCategory": "Productivity",
        "operatingSystem": "iOS",
        "name": "Streak Pulse",
        "description": "Gamified task management and habit tracking",
        "url": "https://www.streakpulse.com",
        "offers": {
          "@type": "Offer",
          "price": "0",
          "priceCurrency": "USD"
        }
      },
      {
        "@type": "WebApplication",
        "applicationCategory": "Travel",
        "name": "Think Globally Live Locally",
        "description": "Curated travel guide platform",
        "url": "https://www.thinkgloballylivelocally.com"
      }
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
}; 